import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setDairyCowSales, setDairyCowSalesAdmin } from "services";

import { footprintingDairyPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_DAIRY_COWS_SOLD } from "consts";

import { UploadableCowSales } from "models";

export const useMutateFootprintingDairyCowSales = (farmId: string, year: number, payload: UploadableCowSales, primaryDataId: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_DAIRY_COWS_SOLD, primaryDataId, isAdmin],
      mutationFn: () => (isAdmin ? setDairyCowSalesAdmin(primaryDataId, payload) : setDairyCowSales(primaryDataId, payload)),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_DAIRY_COWS_SOLD, primaryDataId, isAdmin],
          ...footprintingDairyPrimaryQueryKeys(primaryDataId, farmId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
